import { Divider, HStack, Icon, VStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface PricingCardProps {
  title: string;
  description: string;
  price: string;
  llm: string;
  workflowAmount: number;
  gyulAmount: number;
  dashboard: string;
  enterprise: string;
  isSelected?: boolean;
  onBtnTap?: () => void;
  buttonLabel?: string;
}

export const PricingCard = (p: PricingCardProps) => {
  const { t } = useTranslation();

  return (
    <VStack className="w-full gap-[28px] p-[24px] rounded-[16px] outline-outline" whileHover={{ scale: 1.02, y: -4 }}>
      <VStack className="w-full gap-[16px] items-start">
        <VStack className="gap-[2px] items-start">
          <span className="text-[1.5rem] font-semibold text-ct-strong">{p.title}</span>
          <span className="text-sm font-normal text-ct-regular">{p.description}</span>
        </VStack>
        <HStack className="gap-[10px]">
          <span className="text-xl font-semibold text-ct-strong">{p.price}</span>
          <span className="text-md font-medium text-ct-regular">{t("pricing.perMonth")}</span>
        </HStack>
      </VStack>
      <Divider className="w-full" />
      <VStack className="w-full gap-[16px] text-ct-regular text-md font-medium items-start">
        <HStack className="gap-[16px]">
          <Icon name="Robot" />
          <span>{t("pricing.llm", { llm: p.llm })}</span>
        </HStack>
        <HStack className="gap-[16px]">
          <Icon name="Control" />
          <span>{t("pricing.workflow", { workflow: p.workflowAmount })}</span>
        </HStack>
        <HStack className="gap-[16px]">
          <Icon name="Gyul" />
          <span>{t("pricing.gyul", { gyul: p.gyulAmount })}</span>
        </HStack>
        <HStack className="gap-[16px]">
          <Icon name="Dashboard" />
          <span>{t("pricing.dashboard", { dashboard: p.dashboard })}</span>
        </HStack>
        <HStack className="gap-[16px]">
          <Icon name="Enterprise" />
          <span>{t("pricing.enterprise", { enterprise: p.enterprise })}</span>
        </HStack>
      </VStack>
      <button className={`w-full p-[16px] rounded-full text-md font-medium ${p.isSelected ? "bg-bg-regular text-ct-regular" : "bg-pm-strong text-ct-elevated"}`} onClick={p.onBtnTap}>
        {p.isSelected ? t("pricing.selected") : (p.buttonLabel ?? t("pricing.change"))}
      </button>
    </VStack>
  );
};
